export default __webpack_public_path__ + "static/media/depaulProfile.4d1e453b.png";